var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video-bg",attrs:{"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},_vm._l((_vm.sources),function(source,key){return _c('source',{key:key,attrs:{"src":source.src,"type":source.type}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }